import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Select, { StylesConfig } from "react-select";
import { clearRegisterSendmail, registerSendmail } from "../redux/handlers/auth/registerSendmail.handler";
import { mapMstToOptions } from "utils/HelperFunction";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { useAppDispatch, useAppSelector } from "../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { login } from "../redux/handlers/auth/login.handler";
import { VER } from "constants/server/api";
import { LOGO_URL, SERVER_NAME } from "constants/server/config";
import { env } from "env";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { data } from "jquery";
export function RegisterSendMail() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var registerSendmailReducer = useAppSelector(function(state) {
        return state.registerSendmailReducer;
    });
    var _useState = _sliced_to_array(useState(function() {
        return localStorage.getItem("registerEmail") || "";
    }), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = _sliced_to_array(useState(function() {
        return localStorage.getItem("registerToken") || "";
    }), 2), token = _useState1[0], setToken = _useState1[1];
    var _useState2 = _sliced_to_array(useState({
        visible: false,
        textsuccess: "",
        direction: ""
    }), 2), modalsuccess = _useState2[0], setModalsuccess = _useState2[1];
    var handleRegisterSendMail = function() {
        if (!email || email === "" || email === undefined || !token || token === "" | token === undefined) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/register"),
                title: "กรุณาทำรายการสมัครสมาชิกใหม่อีกครั้ง"
            }));
            return;
        }
        var data = {
            token: token,
            mailsend: email
        };
        dispatch(registerSendmail(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        setIsLoading(registerSendmailReducer.isFetching);
        if (registerSendmailReducer.data && !registerSendmailReducer.isError) {
            setModalsuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    visible: true,
                    textsuccess: "ส่งอีเมลสำเร็จ กรุณาตรวจสอบอีเมลของคุณ",
                    direction: undefined
                });
            });
            dispatch(clearRegisterSendmail());
            return;
        }
        if (registerSendmailReducer.data && registerSendmailReducer.isError) {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "เกิดข้อผิดพลาด",
                navigateDirection: navigate("/register"),
                title: "กรุณาทำรายการสมัครสมาชิกใหม่อีกครั้ง"
            }));
            dispatch(clearRegisterSendmail());
            return;
        }
    }, [
        registerSendmailReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "loginpage bg-white",
        children: [
            /*#__PURE__*/ _jsx(Row, {
                className: "g-0",
                children: /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        style: {
                            maxWidth: "550px"
                        },
                        children: /*#__PURE__*/ _jsxs(Card.Body, {
                            className: "",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "d-flex justify-content-center align-items-center mb-3",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "p-3",
                                        style: {
                                            borderRadius: "100px",
                                            backgroundColor: "#8D010C"
                                        },
                                        children: /*#__PURE__*/ _jsx(MailOutlineIcon, {
                                            sx: {
                                                fontSize: 40,
                                                color: "#FFFFFF"
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 tc-1",
                                    children: "ขอบคุณสำหรับการเข้าร่วมเป็นสมาชิก"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 tc-1",
                                    children: "PARDESCO RETAIL AND TRADING"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 mb-4 tc-1",
                                    children: "โปรดยืนยันตัวตนให้เสร็จเพื่อเริ่มใช้งาน"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center fs-16 fw-500 tc-6",
                                    children: [
                                        "เราได้ส่งอีเมลยืนยันไปที่ ",
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "tc-5",
                                            children: email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-16 fw-500 mb-4 tc-6",
                                    children: "เปิดอีเมลและยืนยันบัญชีของคุณ"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-login w-100",
                                    onClick: function() {
                                        return handleRegisterSendMail();
                                    },
                                    children: "ไม่ได้รับอีเมล ? คลิกที่นี่เพื่อส่งอีกครั้ง"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: modalsuccess.visible,
                onHide: function() {
                    return setModalsuccess(function(prev) {
                        return _object_spread_props(_object_spread({}, prev), {
                            visible: false
                        });
                    });
                },
                textsuccess: modalsuccess.textsuccess,
                navigate: navigate,
                direction: modalsuccess.direction
            })
        ]
    });
}
